import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const LogsAPI = {
  getLogs: (page = 1, limit = 10, search = "") =>
    axiosInstance.get(
      `${API_ROUTES.LOGS.GET}?page=${page}&limit=${limit}&search=${search}`,
    ),
};
